import {useMutation} from '@tanstack/react-query';
import {deleteMethodAttachments, uploadMethodAttachments} from 'services/axios/modules';
import {queryClient} from '..';

export const useUploadMethodAttachments = () => {
  return useMutation({
    mutationFn: uploadMethodAttachments,
    onSuccess: () => {
      queryClient.invalidateQueries(['workshops']);
    },
  });
};

export const useDeleteMethodAttachments = () => {
  return useMutation({
    mutationFn: deleteMethodAttachments,
    onSuccess: () => {
      queryClient.invalidateQueries(['workshops']);
    },
  });
};
